// export const BASE_URL = process.env.REACT_APP_BASE_URL ?? "http://localhost:5839";
const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MANAGER_LOGIN = BASE_URL + '/login';
export const FORGOT_PASSWORD = BASE_URL + '/forgot-password';

export const USER_LOOKUP = BASE_URL + '/users/me';

export const GET_USER_API = BASE_URL + '/users/:userId/';
export const USER_CREATE_API = BASE_URL + '/users/';
export const USER_UPDATE_API = BASE_URL + '/users/:userId/';
export const DELETE_USER = BASE_URL + '/users/:userId/';

export const AUDIT_UPLOADS = BASE_URL + '/manager/charts';
export const RECENT_AUDITS = BASE_URL + '/auditsheet/audithours/recent_audits';

export const UPDATE_SUBMITTED_CHART = BASE_URL + '/manager/charts/:id/';

export const GET_SPECIALTIES = BASE_URL + '/manager/specialties';

export const GET_ALL_USER_API = BASE_URL + '/users';

export const GET_SPECIALTIES_FOR_AUDITORS =
  BASE_URL + '/manager/specialties/auditors/';

//chart upload
export const UPLOAD_CHART = BASE_URL + '/manager/charts/files/';
export const SUBMIT_UPLOADED_CHART = BASE_URL + '/client/charts/';
export const DELETE_CHART = BASE_URL + '/manager/charts/files/:fileId/';
export const BULK_DELETE_CHART_UPLOADS = BASE_URL + '/client/charts/files/bulk-delete/'
export const GET_CLIENT_SPECIALTIES_PROVIDERS_MAP = BASE_URL + '/client/dashboard/get-specialties-providers-map';
export const LOGOUT = BASE_URL + '/logout';
export const GET_CLIENT_USER = BASE_URL + '/manager/charts/clients';
export const ATTACH_FILES_TO_CHART = BASE_URL + '/manager/charts/:chartId/attach-files/';
export const DELETE_UPLOADED_FILE = BASE_URL + '/manager/charts/:uploadID/';

//TEAMS
export const TEAMS = BASE_URL + '/manager/teams/';
export const REVIEWER = BASE_URL + '/users/all_reviewer/';
export const TOGGLE_USER_STATUS = BASE_URL + '/users/:userId/toggle_user_status/';
export const MANAGE_TEAMS = BASE_URL + '/manager/teams/:teamId/';
export const MEMBER_LIST = BASE_URL + '/manager/teams/members_list';
export const TEAM_CHART_ACCURACY =
  BASE_URL + '/auditsheet/metric/chart-accuracy/';
export const TEAM_AVERAGE_AUDIT_HOURS =
  BASE_URL + '/auditsheet/audithours/average/';

//SPLIT AUDIT
export const SPLIT_AUDIT = BASE_URL + '/manager/split-audit/:uploadId/';
export const GET_AUDITOR = BASE_URL + '/manager/specialties/auditors/';
export const CHART_ACCURACY = BASE_URL + '/auditsheet/metric/chart-accuracy/';
export const AVERAGE_AUDIT_HOURS = BASE_URL + '/auditsheet/audithours/average/';

//AUDIT SHEET
export const AUDIT_SHEET = BASE_URL + '/auditsheet/:uploadId/';
export const AUDIT_SHEET_DELTA = BASE_URL + '/auditsheet/:uploadId/delta-update/';
export const MONITOR_HOUR = BASE_URL + '/auditsheet/audithours/:uploadId/';
export const AUDIT_UPLOAD = BASE_URL + '/manager/charts/:uploadId/';
export const AUDIT_SHEET_INDUSTRY = BASE_URL + '/auditsheet/industry/';
export const AUDIT_SHEET_ICD_CODES = BASE_URL + '/auditsheet/icd-code/';
export const AUDIT_SHEET_MODIFIER = BASE_URL + '/auditsheet/modifier/';
export const UPDATE_ACTIVITY =
  BASE_URL + '/auditsheet/comment/updation_activity/';
export const AUDITSHEET_USER = BASE_URL + '/auditsheet/cqusers/';
export const DELETE_TEAMS_USER = BASE_URL + '/users/:userId/';
export const GET_COMMENT = BASE_URL + '/auditsheet/comment/:uploadId';
export const MANAGE_COMMENT = BASE_URL + '/auditsheet/comment/:commentId/';
export const POST_COMMENT = BASE_URL + '/auditsheet/comment/';
export const AUDIT_REPORT = BASE_URL + '/auditsheet/audit-report/';
export const GET_COMMENT_FLAG =
  BASE_URL + '/auditsheet/comment/:uploadId/cell_flag/';
export const REBUTTAL_SUBMIT_VALIDATION = BASE_URL + '/auditsheet/comment/:uploadId/rebuttal_submit_validation/';
export const GET_BATCH_COMMENT = BASE_URL + '/auditsheet/comment/:batchId/client_comment/';
export const GET_CLIENT_COMMENT_FLAG =
  BASE_URL + '/auditsheet/comment/:batchId/client_cell_flag/';
export const GET_CLIENT_COMMENT =
  BASE_URL + '/auditsheet/comment/:batchId/client_comment';
export const GET_BATCH_ALL_COMMENTS =
  BASE_URL + '/auditsheet/comment/:batchId/batch_all_comments';
export const AUDIT_SHEET_PROVIDER_DROPDOWN =
  BASE_URL + '/client/dashboard/:chartId/provider_dropdown/';
export const AUDIT_SHEET_RESPONSE_ISSUES_DROPDOWN =
  BASE_URL + '/auditsheet/response_options/';
export const AUDIT_SHEET_EXPORT = BASE_URL + "/auditsheet/audit-data-export"
// users/2/

// accounts
export const ACCOUNTS_LIST = BASE_URL + '/manager/accounts/healthsystem/';
export const DELETE_ACCOUNT =
  BASE_URL + '/manager/accounts/healthsystem/:healthsystemId/';
export const ACRHIVED_ACCOUNTS_LIST = BASE_URL + '/manager/accounts/healthsystem/archived';
export const RESTORE_ACCOUNT = BASE_URL + '/manager/accounts/healthsystem/:healthsystemId/unarchive/';

// department account
export const CREATE_DEPARTMENT =
  BASE_URL + '/manager/accounts/department/:hospitalId/';
export const DEPARTMENT =
  BASE_URL + '/manager/accounts/department/:departmentId/';
export const ALL_DEPARTMENT = BASE_URL + '/manager/accounts/department/';
export const GET_DEPARTMENT_DROPDOWN =
  BASE_URL + '/manager/accounts/department/:hospitalId/department_dropdown/';

//hospital
export const HOSPITAL = BASE_URL + '/manager/accounts/hospital/:hospitalId/';
export const CREATE_HOSPITAL =
  BASE_URL + '/manager/accounts/hospital/:health_system/';

//create accounts
export const EHR_LIST = BASE_URL + '/manager/ehr/';
export const INSURANCE_LIST = BASE_URL + '/manager/insurance/';

//hospitals
export const HOSPITAL_LIST = BASE_URL + '/manager/accounts/hospital/';
export const HEALTH_SYSTEM_INFO =
  BASE_URL + '/manager/accounts/healthsystem/:healthSystemId/';

//REPORT
export const WEEK_WISE_ERROR =
  // BASE_URL + '/auditsheet/report/week-wise-error-trend/';
  BASE_URL + '/auditsheet/report/week-wise-error/';

export const WEEK_WISE_ERROR_TREND =
  BASE_URL + '/auditsheet/report/week-wise-error-trend/';

export const WEEKDAYS_ACCURACY_CHART =
  BASE_URL + '/auditsheet/report/weekdays-accuracy/';
export const WEEK_WISE_CQ_ACCURACY_ERROR =
  BASE_URL + '/auditsheet/report/cq-accuracy-error/';
export const ERROR_DROPDOWN =
  BASE_URL + '/auditsheet/report/error-parameter-dropdown/';

export const AUDITOR_QUALITY_DROPDOWN =
  BASE_URL + '/auditsheet/report/auditor-dropdown/';
export const AUDITOR_QUALITY_REPORT =
  BASE_URL + '/auditsheet/report/auditor-quality/';

export const GET_ACCOUNT =
  BASE_URL + '/manager/accounts/healthsystem/:accountId/';
export const GET_ACCOUNT_MEMBERS =
  BASE_URL + '/manager/accounts/healthsystem/:accountId/clients/';
export const GET_ACCOUNT_HOSPITALS =
  BASE_URL + '/manager/accounts/healthsystem/:accountId/hospitals/';
export const GET_ACCOUNT_TEAM_STATISTICS =
  BASE_URL + '/manager/accounts/healthsystem/team-statistics/';
export const GET_ACCOUNT_DEPARTMENTS =
  BASE_URL + '/manager/accounts/healthsystem/:accountId/department/';
export const GET_CLIENT_SPOC_LIST = BASE_URL + '/manager/common-client/spoc-list/';

export const GET_ACCOUNT_AVERAGE_AUDITHOURS =
  BASE_URL + '/auditsheet/audithours/average/';

export const METRIC_CHART_ACCURACY =
  BASE_URL + '/auditsheet/metric/chart-accuracy/';

export const GET_HEALTH_SYSTEM = BASE_URL + '/auditsheet/health-system/';
export const GET_HOSPITAL = BASE_URL + '/auditsheet/health-system/hospitals/';
export const GET_SPECIALTY =
  BASE_URL + '/auditsheet/health-system/specialties/';

export const GET_ACCOUNT_PROVIDERS =
  BASE_URL + '/manager/accounts/healthsystem/:accountId/providers/';

export const GET_HOSPITAL_DATA =
  BASE_URL + '/manager/accounts/hospital/:hospitalID/';
export const GET_PROVIDER_LIST = BASE_URL + '/manager/accounts/provider/';
export const CREATE_PROVIDER_WITH_ID =
  BASE_URL + '/manager/accounts/provider/:departmentID/';
export const CREATE_PROVIDER =
  BASE_URL + '/manager/accounts/provider/:departmentID/';
export const MOODLE_ACTION = BASE_URL + '/client/moodle-users/';
export const MOODLE_ACTION_MODIFY = BASE_URL + '/client/moodle-users/:providerId/';
export const MOODLE_SYNC_PROVIDER_BY_DEPARTMENT = BASE_URL + '/client/moodle-users/:departmentID/sync-providers';
export const GET_PROVIDER_BY_DEPARTMENT =
  BASE_URL + '/manager/accounts/department/:departmentID/providers';
export const GET_PROVIDER =
  BASE_URL + '/manager/accounts/provider/:providerId/';
export const UPDATE_PROVIDER =
  BASE_URL + '/manager/accounts/provider/:providerId/';
export const DELETE_PROVIDER =
  BASE_URL + '/manager/accounts/provider/:providerId/';
export const GET_ALL_DEPARTMENTS_BY_HS = 
  BASE_URL + '/manager/accounts/department/:healthSystemID/all_department_by_hs/';

export const CREATE_HEALTH_SYSTEM =
  BASE_URL + '/manager/accounts/healthsystem/';

// notifications
export const GET_NOTIFICATIONS = BASE_URL + '/notifications/';

export const CHANGE_NOTIFICATION_STATUS =
  BASE_URL + '/notifications/:notificationId/';

export const MARK_ALL_READ_NOTIFICATIONS = BASE_URL + '/notifications/mark_all_read/';

// validations
export const HEALTH_SYSTEM_VALIDATION =
  BASE_URL + '/manager/accounts/healthsystem/validation';

// all users mail id

export const CQ_USERS_MAIL_ID = BASE_URL + '/users/all';

export const CQ_HOSPITAL_DATA =
  BASE_URL + '/manager/accounts/hospital/validation';

export const CQ_DEPARTMENTS_DATA =
  BASE_URL + '/manager/accounts/department/validation';

export const GET_FAQ = BASE_URL + '/faq/';

export const HOSPITAL_DEPARTMENTS =
  BASE_URL + '/client/dashboard/department-list/';

export const PHYSICIAN_LIST = BASE_URL + '/client/dashboard/physician-list/';

export const AUTH_MANAGER_CLIENT_TOKEN = BASE_URL + '/users/auth_manager';
export const GET_PAYOR_CONTRACT = BASE_URL + '/client/payor-contract/';
export const GET_COMP = BASE_URL + '/client/compliance/upload/';

// for getting client tiles click data
export const DASHBOARD_TILES_CLICK_STATS = BASE_URL + '/client/dashboard/tiles-click-stats';

// for cms data
export const CMS_DATA_COUNT = BASE_URL + '/manager/cms-data/count/';
export const SPEC_VISITS_PER_PROV_PERCENTILE = BASE_URL + '/manager/cms-data/spec-visits-per-prov-percentile';
export const CMS_SPEC_COUNT = BASE_URL + '/manager/cms-data/cms_spec_count';

//Qualification
export const QUALIFICATION = BASE_URL + '/client/qualifications/';
export const QUALIFICATION_TO_CLIENT = BASE_URL + '/client/qualifications/attach-to-client/:providerId/';

//HEALTH SYSTEM PERMANENT DELETE
export const HEALTH_SYSTEM_PERMANENT_DELETE = BASE_URL + '/client/health-system/:accountId/permanent-delete/';

// batch name validation
export const VALIDATE_BATCH_NAME = BASE_URL + '/client/dashboard/validate-batch-name';

// version 2 get charts
export const MY_CHARTS = BASE_URL + '/client/dashboard/';
export const GET_CLIENT_SPECIALTIES = BASE_URL + '/client/dashboard/get-specialties';
export const CHART_UPDATE_V2 = BASE_URL + '/manager/charts/update-v2/';
export const REVIEWERS = BASE_URL + '/manager/specialties/reviewers'

// batch audit sheet
export const BATCH_AUDIT_SHEET =
  BASE_URL + '/client/dashboard/:batchId/auditsheet/';

export const GET_FILE_BY_BATCH =
  BASE_URL + '/client/dashboard/:batchId/batchresult';

export const ACCOUNTS_HIERARCHY_TREE = BASE_URL + '/client/dashboard/hierarchy-tree-v2/';